var $ = (typeof window !== "undefined" ? window['jQuery'] : typeof global !== "undefined" ? global['jQuery'] : null);
var initializeModules = require( "./lib/init-modules.js" );
var initializeBackToTop = require( "./lib/init-back-to-top.js" );
var initializeVideoModal = require( "./lib/init-video-modal.js" );

// Dependencies
require( "bootstrap/transition" );
require( "bootstrap/collapse" );
require( "bootstrap/modal" );
require( "debounce" );
require( "velocity-animate" );
require( "velocity-animate/velocity.ui" );
require( "picturefill" );

// Vendor
require( "./vendor/modernizr-custom.js" );

// Custom
require( "./lib/images.js" )();
require( "./lib/template.js" )();
require( "./lib/video-tracking.js" )();

$(function() {
	initializeModules();
	initializeBackToTop();
	initializeVideoModal();
});
